import styled from 'styled-components';

import { DropdownPrimitives } from '../../../TakeoverInput';
import LocationIcon from './assets/LocationIcon.svg';


export const Wrapper = styled.div`
    position: relative;

    ${DropdownPrimitives.FieldInput} {
        padding-right: ${p => p.locationIconVisible ? '52px' : ''};
    }
`;

export const StyledLocationIcon = styled.div`
    background: url(${LocationIcon});
    height: 24px;
    width: 24px;
`;

export const InlineLocationIcon = styled(StyledLocationIcon)`
    display: inline-block;
    margin-left: 6px;
    vertical-align: middle;

    height: 20px;
    width: 20px;
`;

export const PositionedLocationIcon = styled(StyledLocationIcon)`
    position: absolute;
    margin-bottom: auto;
    margin-top: auto;
    top: 0;
    right: 16px;
    bottom: 0;
`;

export const PoweredByGoogleContainer = styled.div`
    margin-top: 6px;
    text-align: left;
`;
